module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_uk.c7423986.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_uk.png
// module id = 1258
// module chunks = 16